var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, submitEventHandler, PICBase, PIC, PICAction, booleanDecoder } from '../Internals';
import { classMap } from 'lit/directives/class-map.js';
import { state, queryAll, property } from 'lit/decorators.js';
let ChoiceBox = class ChoiceBox extends PICBase {
    constructor() {
        super();
        this.chooseBtnFocus_ = false;
        this.errorCode = '';
        this.isNew = false;
        this.ctitle = '';
        this.choices = [{ choiceText: 'ok', choiceEvent: '', chooseBtnFocus: false }];
        this.hidden_ = true;
        this.submitE = {
            cb: this,
            handleEvent(event) {
                let eventid = event.target.getAttribute('data-event');
                if (!eventid)
                    this.cb.closeModal(event);
                else {
                    this.cb.closeModal(event);
                    submitEventHandler(event, eventid, { force: true });
                }
            }
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.isPicComp_ = false;
        let events = this.getAttributeNames().filter(name => name.startsWith('event-'));
        let title = this.getAttribute('xtitle');
        let choices = [];
        if (events.length > 0) {
            events.map(attrName => {
                let attr = this.getAttribute(attrName);
                if (attr !== null && attr.indexOf('~') > -1) {
                    let [choiceText, choiceEvent] = attr.split('~');
                    let c = { choiceText: choiceText !== null && choiceText !== void 0 ? choiceText : '', choiceEvent: choiceEvent !== null && choiceEvent !== void 0 ? choiceEvent : '' };
                    //let choiceEvent = attr.split('~')[1]
                    choices.push(c);
                }
            });
        }
        if (title != null && title.length > 0 && choices.length > 0) {
            events.forEach(ev => this.removeAttribute(ev));
            this.removeAttribute('xTitle');
            this.data = { choiceTitle: title, choices, attributes: { hidden_: true } };
        }
        this.requestUpdate();
    }
    set data(data) {
        var _a;
        this.ctitle = data.choiceTitle;
        this.isNew = PIC.getInstance.webVersion == '3';
        /*this.isNew = data.isNew ?? false;*/
        if (data.choices != null)
            this.choices = data.choices;
        if (data.attributes) {
            let attrs = data.attributes;
            for (let attr in attrs) {
                if (this.hasOwnProperty(attr))
                    this[attr] = attrs[attr];
            }
        }
        this.errorCode = (_a = data.errorCode) !== null && _a !== void 0 ? _a : '';
        this.requestUpdate();
    }
    /**
     * test doc
     */
    openBox() {
        this.hidden_ = false;
        this.requestUpdate();
    }
    closeBox() {
        this.hidden_ = true;
        this.requestUpdate();
    }
    updated(_changedProperties) {
        let tmpBool = false;
        this.choices.forEach(choice => {
            if (choice.chooseBtnFocus === true) {
                this.btns[this.choices.indexOf(choice)].focus();
                tmpBool = true;
            }
        });
        if (!tmpBool)
            this.btns[this.btns.length - 1].focus();
    }
    closeModal(event) {
        if (!event.target)
            return;
        this.hidden_ = true;
        this.requestUpdate();
    }
    renderChoiceButton(iChoice, disabled) {
        var _a;
        iChoice.choiceEvent = (_a = iChoice.choiceEvent) !== null && _a !== void 0 ? _a : ''; //undefined/null -> ''
        if (iChoice.eventFnc) {
            let ref = this;
            let wrappedF = () => {
                if (iChoice.eventFnc instanceof PICAction)
                    iChoice.eventFnc.triggerEvent();
                else
                    iChoice.eventFnc();
                ref.hidden_ = true;
                ref.requestUpdate();
            };
            return html `
                <button class="button choice-button" @click=${wrappedF} ?disabled=${disabled}>${iChoice.choiceText}</button>
            `;
        }
        else {
            return html `
		    	<button class="button choice-button" data-event="${iChoice.choiceEvent}" @click=${this.submitE} ?disabled=${disabled}>${iChoice.choiceText}</button>
            `;
        }
    }
    getTitleClass() {
        return {
            'container-title': true,
            'pic-h6': this.isNew
        };
    }
    render() {
        let bgclasses = {
            'bgfade': true,
            'hidden': this.hidden_,
            'skiptranslate': true
        };
        let modalClasses = {
            'modal': true,
            'newChoiceBox': this.isNew === true,
            'newModal-pinnedNav': PIC.getInstance.userConfig.isNavDrawerPinned === true && document.querySelector('pic-navdrawer') !== null,
            'newModal-outlinedNav': PIC.getInstance.userConfig.isNavDrawerPinned === false && document.querySelector('pic-navdrawer') !== null,
        };
        let titleArr = this.ctitle.split('\n'); // prevent newlines from getting ignored
        return html `
            ${this.renderCSS(true)}
            <style>
                :host{
                    --pic-buttonContainedFocusBGColor: 
                    linear-gradient(to right, var(--pic-whiteOverlayFocusColor), var(--pic-whiteOverlayFocusColor)),
                    linear-gradient(to right, var(--pic-primaryColor), var(--pic-primaryColor));
                }
                .pic-h6 h1 {
                    font-weight: bold;
                }
                .bgfade {
                    display: block;
                    position: fixed;
                    z-index: var(--pic-choiceZIndex, 999999);
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    background-color: rgba(0, 0, 0, 0.4);
                }
                .bgfade.hidden {
                    display: none;
                }
                .modal {
                    max-width: 800px;
                    min-width: 20%;
                    width: fit-content;
                    width: -moz-fit-content;
                    background-color: #fefefe;
                    padding: 20px;
                    border: 1px solid black;
                    margin: 0;
                    position: absolute;
                    top: 30%;
                    left: 50%;
                    -ms-transform: translate(-50%, -30%);
                    transform: translate(-50%, -30%);
                    max-height: 60vh;
                }
                .modal-close {
                    cursor: pointer;
                    color: #aaa;
                    float: right;
                    font-size: 28px;
                    font-weight: bold;
                }
                .modal div {
                    font-size: 0.8em;
                    max-height: 40em;
                }
                .container-title {
                    border-bottom: 1px solid black;
                    overflow-y: auto;
                }
                h1 { 
                    max-height: 50vh;
                    overflow-wrap: normal;
                }
                .container-choice {
                    margin-top: 1em;
                    display: flex;
                    flex-flow: row wrap;
                    justify-content: flex-end; 
                }
                button {
                    margin-left: 1em;
                    text-align: center;
                    min-width: 4em;
                    width: fit-content;
                    background: var(--buttonColor, var(--pic-primaryColor, black));
                    border: 1px solid var(--buttonColor, var(--pic-primaryColor, black));
                    color: white;
                    height: 2em;
                    border-radius: 7%;
                }
                
                button:hover{
                    opacity: 0.8;
                }
                
                /* New choicebox */
                .newChoiceBox {
                    right: 5%;
                    top: 5%;
                    bottom: 5%;
                    margin: auto;
                    border: none;
                    border-radius: 4px;
                    width: fit-content;
                    height: fit-content;
                    transform: none;
                    -ms-transform: none;
                }
                .newChoiceBox > .modal-close {
                    position: absolute;
                    margin: 10px;
                    right: 0px !important;
                    top: 0px !important;
                    line-height: 16px;
                }
                .newChoiceBox > .error-code {
                    color: #aaa;
                    position: absolute;
                    margin: 10px;
                    top: 0px !important;
                    left: 0 !important;
                    font-size: 0.8em;
                    line-height: 16px;
                }
                .newChoiceBox > button {
                    border: none;
                }
                .newModal-pinnedNav {
                    left: calc(250px + 5%);
                }
                .newModal-outlinedNav {
                    left: calc(60px + 5%);
                }
                /* Themed surfaces, web3 only - the shared .modal/.modal-close/
                   button rules above keep their literal colors so web2.5
                   renders unchanged. Without an explicit color here the title
                   inherits the page's light-on-dark ink onto a white dialog. */
                .newChoiceBox {
                    background-color: var(--pic-surfaceColor, #fefefe);
                    color: var(--pic-onSurfaceHighColor, black);
                }
                .newChoiceBox .container-title {
                    border-bottom-color: var(--pic-outline, black);
                }
                .newChoiceBox .modal-close,
                .newChoiceBox .error-code {
                    color: var(--pic-onSurfaceMediumColor, #aaa);
                }
                .newChoiceBox button {
                    color: var(--pic-onPrimaryHighColor, white);
                }
                button:focus {
                    background-color: unset;
                    background-image: var(--pic-buttonContainedFocusBGColor, #275d8c);
                    box-shadow: rgba(0, 0, 0, 0.14) 0px 6px 10px, rgba(0, 0, 0, 0.12) 0px 1px 18px, rgba(0, 0, 0, 0.2) 0px 3px 5px;
                    outline: none;
                    color: var(--pic-onPrimaryHighColor);
                    /* var(--pic-buttonFocusBGColor) add to webtoolbox.css */
                }
                
            </style>			
            <div class=${classMap(bgclasses)} >
                <div class=${classMap(modalClasses)}>
                    ${this.errorCode.length > 0 ? html `<span class="error-code">[${this.errorCode}]</span>` : ''}
                    <span class="modal-close" @click=${this.closeModal}>&times;</span>
                    <div class=${classMap(this.getTitleClass())}>
                        ${titleArr.map((t) => renderChoiceTitle(this, t))}
                    </div>
                    <div class="container-choice">
                        ${this.choices.map(c => this.renderChoiceButton(c, false))}
                    </div>
                </div>
            </div>
        `;
        function renderChoiceTitle(ref, iT) {
            return html `
                <h1 class=${ref.isNew ? 'pic-h6' : ''}>${iT}</h1>
            `;
        }
    }
};
__decorate([
    queryAll('.choice-button')
], ChoiceBox.prototype, "btns", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'chooseBtnFocus' })
], ChoiceBox.prototype, "chooseBtnFocus_", void 0);
__decorate([
    property()
], ChoiceBox.prototype, "errorCode", void 0);
__decorate([
    state()
], ChoiceBox.prototype, "isNew", void 0);
ChoiceBox = __decorate([
    customElement('pic-choicebox')
], ChoiceBox);
export { ChoiceBox };
//# sourceMappingURL=ChoiceBox.js.map